<mat-dialog-content class="modal-header"><h2 mat-dialog-title>VALIDAR VEHÍCULO</h2></mat-dialog-content>
<mat-dialog-content class="modal-body">

  <div class="content">
    <app-vehiculo-form [vehiculo]="model" [disabled]="true"></app-vehiculo-form>
  </div>  

  <div class="content">
    <div class="block">
      <!-- <div class="block-header">
        <h3 class="block-title">Documentación Requerida</h3>
      </div> -->

      <div class="block-content">
        <mat-tab-group>
          <mat-tab label="Documentos">
            <div class="table-responsive">
              <table mat-table [dataSource]="model.documentos" class="table table-striped table-vcenter">
                <ng-container matColumnDef="nombre">
                  <th mat-header-cell *matHeaderCellDef>Nombre</th>
                  <td mat-cell *matCellDef="let element">{{ element.documento }}</td>
                </ng-container>
        
                <ng-container matColumnDef="idRequisito">
                  <th mat-header-cell *matHeaderCellDef>Requisito</th>
                  <td mat-cell *matCellDef="let element" class="centre">{{ element.requisito }}</td>
                </ng-container>

                <ng-container matColumnDef="fechaVencimiento">
                  <th mat-header-cell *matHeaderCellDef>Fecha de vencimiento</th>
                  <td mat-cell *matCellDef="let element" class="centre">
                    {{ element.fechaVencimiento | date: "dd/MM/yyyy"}}
                  </td>
                </ng-container>

                <ng-container matColumnDef="idDocumento">
                  <th mat-header-cell *matHeaderCellDef>Doc.</th>
                  <td mat-cell *matCellDef="let element">
                    <!-- <a>VER</a> -->
                  <a (click)="downloadDocumentFromService(element)">{{element.nombreArchivo}}</a>
                  </td>
                </ng-container>

                <ng-container matColumnDef="aprobado">
                  <th mat-header-cell *matHeaderCellDef>Aprobado</th>
                  <td mat-cell *matCellDef="let element" class="centre"> 
                    <mat-slide-toggle 
                      [(ngModel)]="element.aprobado" 
                      (change)="changeAprobado(element)"
                      [disabled]="model.completado || modelVehiculo.idEstado === 2"
                    >
                    <!-- *ngIf="element.nombreArchivo != ''" -->
                                <!-- <p *ngIf="element.blnEstado"></p>
                                <p *ngIf="!element.blnEstado"></p>                           -->
                    </mat-slide-toggle>
                  </td>
                </ng-container>
      
                <ng-container matColumnDef="observado">
                  <th mat-header-cell *matHeaderCellDef>Observado</th>
                  <td mat-cell *matCellDef="let element"> 
                    <mat-slide-toggle 
                      [(ngModel)]="element.observado" 
                      (change)="changeObservado(element)" 
                      class="observado"
                      [disabled]="model.completado || modelVehiculo.idEstado === 2"
                    >
                    <!-- *ngIf="element.nombreArchivo != ''" -->
                                <!-- <p *ngIf="element.blnEstado"></p>
                                <p *ngIf="!element.blnEstado"></p>                           -->
                    </mat-slide-toggle>
                  </td>
                </ng-container>
                
                <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
                <tr mat-row *matRowDef="let row; columns: displayedColumns"></tr>
              </table>
            </div>
          </mat-tab>
          <mat-tab label="Historial Comentarios">
            <app-log-table [listaLogModel]="model.logs"></app-log-table>
          </mat-tab>
        </mat-tab-group>
      </div>
    </div>
  </div>
  
  <div class="content">
    <div class="form-horizontal">
      <div class="form-group">
        <label class="col-md-2 control-label">Comentarios:</label>
        <div class="col-md-9">
          <mat-form-field class="example-full-width" appearance="outline">
            <mat-label>Comentarios</mat-label>
            <textarea
              matInput
              placeholder="Comentarios"
              [(ngModel)]="modelVehiculo.comentarios"
              rows="5"
              name="comentarios" [maxlength]="2000"
              [disabled]="model.completado || modelVehiculo.idEstado === 2"               
            ></textarea>
            <!-- [disabled]="modelVehiculo.idEstado !== 0" -->
          </mat-form-field>
        </div>
      </div>
    </div>
  </div>
</mat-dialog-content>

<mat-dialog-actions align="end" class="modal-actions">
  <button class="btn btn-naranja" *ngIf="!model.completado && modelVehiculo.idEstado !== 2" mat-button (click)="enviar()" cdkFocusInitial><mat-icon>save</mat-icon> GUARDAR</button>  
  <button class="btn btn-naranja2" mat-button (click)="onNoClick()"><mat-icon>exit_to_app</mat-icon> SALIR</button>
</mat-dialog-actions>

<!-- <pre>{{data | json}}</pre> -->

